var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconModelPlay = function SvgIconModelPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#318DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.55 37.477V18.523c0-2.315 2.512-3.758 4.512-2.591l16.247 9.477c1.984 1.157 1.984 4.024 0 5.182l-16.247 9.477c-2 1.167-4.511-.276-4.511-2.591"
  }))));
};
export default SvgIconModelPlay;